import GenericTable from '../../../../../cars/components/V3/_shared/GenericTable/GenericTable'
import { TableMobileCardContent } from '../../../../../cars/components/V3/_shared/GenericTable/TableMobileCardContent'
import purchaseReportDetailsData from './purchaseReportDetailsColumns'
import { useNavigate } from 'react-router-dom'
import type { PurchaseReportDetails } from '../../../../../../types'
import type { Row } from '@tanstack/react-table'
import { formatCurrency } from '../../../utils/formatCurrency'

type PurchaseReportDetailsTableProps = {
  data: any
  isLoading?: boolean
  options: { year: string; month: string }
}

function PurchaseReportDetailsTable({ data, isLoading, options }: PurchaseReportDetailsTableProps) {
  const columns = purchaseReportDetailsData({ options })

  return (
    <GenericTable
      className="max-h-[50vh]"
      data={data}
      columns={columns}
      isLoading={isLoading}
      mobileCardContent={(row) => {
        return <MobileCardContent row={row} options={options} />
      }}
    />
  )
}

export default PurchaseReportDetailsTable

function MobileCardContent({
  row,
  options,
}: {
  row: Row<PurchaseReportDetails>
  options: { year: string; month: string }
}) {
  const navigate = useNavigate()

  const header = row.original?.regNo || row.original?.vehicleID
  const data = [
    {
      label: 'Objekt',
      value: row.original.carDescription || '',
    },
    {
      label: 'Fakturagruppe',
      value: row.original.invoiceGroupingDescription || '',
    },
    {
      label: 'Beløp',
      value: formatCurrency(row.original.amountincVAT),
    },
    {
      label: 'Kjøretøy-ID',
      value: row.original.vehicleID || '',
    },
    {
      label: 'Sjåfør',
      value: row.original.driverName || '',
    },
  ]

  const action = {
    onClick: () => {
      navigate(`/reports/purchase/${options.year}-${options.month}/?regNo=${row.original.regNo}`)
    },
  }

  return <TableMobileCardContent header={header} data={data} action={action} />
}
